module.exports = __webpack_public_path__ + "static/media/s4g_card.0bd32795.png";